import React, {useEffect } from 'react'; 
 import Popup from '../Component/Popup'
 import Header from '../Component/Header'
 import HomeSlider from '../Component/HomeSlider'  
 import Events from '../Component/Events'
 import Message from '../Component/Message'
 //import Campuscare from '../Component/Campuscare'
 import OnlineRegistration from '../Component/OnlineRegistration'
 import Gallery from '../Component/Gallery' 
 import Footer from '../Component/Footer'
import { Link } from 'react-router-dom'
import LazyLoad from 'react-lazyload';
const Home = () => {
  useEffect(() => {
    document.title = 'Home -  CARMEL CONVENT SCHOOL, DHARUHERA';  
}, []); 
  return (
    <> 
       {/* <Campuscare />  */}
      <Popup /> 
      <Header />
       <OnlineRegistration /> 
      <HomeSlider /> 
<div className='container'>
  <div className='row'>
    <div className='col-md-12'>
    <div className="aboutmidsec padded-sec">
        <div className='button'>
          <Link to="/" target="_blank">
            <LazyLoad><img src="https://webapi.entab.info/api/image/CCSDH/public/Images/mission.gif"  alt="Carmel Convent School, dharuhera" /></LazyLoad>
            <p className='abt-txt'>Mission & Vision</p>
            <p className='read_more'><Link to="/VisionMission">READ MORE </Link><i class="bi bi-chevron-double-right"></i></p>
          </Link>
        </div>
        <div className='button'>
          <Link to="/" target="_blank">
            <LazyLoad><img src="https://webapi.entab.info/api/image/CCSDH/public/Images/history.gif"  alt="Carmel Convent School, dharuhera" /></LazyLoad>
            <p className='abt-txt'>Our history</p>
            <p className='read_more'><Link to="/OurHistory">READ MORE</Link> <i class="bi bi-chevron-double-right"></i></p>
          </Link>
        </div>
        <div className='button'>
          <Link to="/Club" target="_blank">
            <LazyLoad><img src="https://webapi.entab.info/api/image/CCSDH/public/Images/Club.gif"  alt="Carmel Convent School, dharuhera" /></LazyLoad>
            <p className='abt-txt'>Club</p>
            <p className='read_more'>READ MORE <i class="bi bi-chevron-double-right"></i></p>
          </Link>
        </div>
        <div className='button'>
          <Link to="/" target="_blank">
            <LazyLoad><img src="https://webapi.entab.info/api/image/CCSDH/public/Images/sport.png"  alt="Carmel Convent School, dharuhera" /></LazyLoad>
            <p className='abt-txt'>Sports</p>
            <p className='read_more'>READ MORE <i class="bi bi-chevron-double-right"></i></p>
          </Link>
        </div>
        <div className='button'>
          <Link to="/SquadSystem">
            <LazyLoad><img src="https://webapi.entab.info/api/image/CCSDH/public/Images/Squad.gif"  alt="Carmel Convent School, dharuhera" /></LazyLoad>
            <p className='abt-txt'>Squad</p>
            <p className='read_more'>READ MORE <i class="bi bi-chevron-double-right"></i></p>
          </Link>
        </div>
      </div>
    </div>
  </div>
</div>
     
      <div className="aboutsec">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div class="about-news">
                <div className='sixtyYrs'>
                  {/* <h1>60<span>+</span></h1>
                  <p>Years Of Experience</p> */}
                </div>
                <LazyLoad><img src="https://webapi.entab.info/api/image/CCSDH/public/Images/about.png" className='img-fluid' alt="Carmel Convent School, dharuhera" /></LazyLoad>
              </div>
            </div>
            <div className="col-lg-6">
              <div className='title'>
                <p>About us<LazyLoad> <img src='https://webapi.entab.info/api/image/CCSDH/public/Images/abt.gif' className='img-fluid' alt="Carmel Convent School, dharuhera" /> </LazyLoad></p>
                <h2>Carmel Convent School, dharuhera</h2>
              </div>
              <p>Started on July 1, 2022, Carmel Convent School, Dharuhera has a spacious campus with well planned buildings and playgrounds. The school is recognized by the Directorate of Education of Haryana. It is affiliated to the Central board of secondary education. </p>

              <p>The Foundation stone of Carmel convent School, Dharuhera was laid by Rev. Msgr. Wolfgang Johann Huber President of ‘Missio’, Munich, Germany on September 14, 2019 in the presence of Sister Maria Nirmalini A.C. (Superior General) of the Apostolic Carmel Congregation. It was inaugurated by Sister Nirmalini and blessed by Bishop Deepak Tauro Auxiliary Bishop of the Archdiocese of Delhi. </p>
              <button className='read-more'><Link to="/AboutUs">Read More</Link> <i class="bi bi-chevron-right"></i></button>
            </div>
          </div>
        </div>
      </div>
     <div className='three-block'>
      <div className='container'>
        <div className='row'>
        <div className="col-lg-12">
        <div className='title'>
        <LazyLoad>   <p>Upcoming  events  <img src='https://webapi.entab.info/api/image/CCSDH/public/Images/calender.gif'  alt="Carmel Convent School, dharuhera" className='img-fluid' /></p></LazyLoad>
            <h2>School events</h2>
          </div>
         </div>
          <div className='col-md-4'>
            <div className='three-block_list'>
            <h3> Pre-Primary </h3>
            <div className="img-blk">
            <LazyLoad><img src="https://webapi.entab.info/api/image/CCSDH/public/Images/pre-primary.gif" className='img-fluid' alt="Carmel Convent School, dharuhera" /> </LazyLoad>
            </div>
            <p className='bg'><i>Lower and Upper KG</i></p>
            <p>The pre primary school has stimulating programmes where each child can actively engage in exciting new experiences</p>
            <h4> <Link to="https://webapi.entab.info/api/image/CCSDH/public/pdf/AcademicCalender.pdf" target="_blank"> Read More <i class="bi bi-chevron-double-right"></i></Link></h4>
            </div>
          </div>
          <div className='col-md-4'>
            <div className='three-block_list'>
            <h3>   Primary</h3>
            <div className="img-blk">
            <LazyLoad><img src="https://webapi.entab.info/api/image/CCSDH/public/Images/primary.gif" className='img-fluid' alt="Carmel Convent School, dharuhera" /> </LazyLoad>
            </div>
            <p className='bg'><i>Classes I-V</i></p>
            <p>The  primary school has helps foster the curiosity of each child. Encourages them to question and become problem solves.</p>
            <h4> <Link to="https://webapi.entab.info/api/image/CCSDH/public/pdf/AcademicCalender.pdf" target="_blank"> Read More <i class="bi bi-chevron-double-right"></i></Link></h4>
            </div>
          </div>
          <div className='col-md-4'>
            <div className='three-block_list'>
            <h3> Secondary </h3>
            <div className="img-blk">
            <LazyLoad><img src="https://webapi.entab.info/api/image/CCSDH/public/Images/alumni.gif" className='img-fluid' alt="Carmel Convent School, dharuhera" /> </LazyLoad>
            </div>
            <p className='bg'><i>Classes VI - VIII</i></p>
            <p>The senior School aims to create lifelong learners and responsible citizens.</p>
            <h4> <Link to="https://webapi.entab.info/api/image/CCSDH/public/pdf/AcademicCalender.pdf" target="_blank"> Read More <i class="bi bi-chevron-double-right"></i></Link></h4>
            </div>
          </div>
        </div>
      </div>
     </div>
      <div className='message'>
        <div className='container'>
         <Message />  
        </div>
      </div>
    <div className='important-link'>
      <div className='container'>
        <div className='row'>
          {/*  <div className='col-md-6 col-lg-4 col-xl-2'>
            <div className='imp-link_blk'>
            <LazyLoad><img src="https://webapi.entab.info/api/image/CCSDH/public/Images/outreach.png" className='img-fluid' alt="Carmel Convent School, dharuhera" /></LazyLoad>
              <h4>Carmel Outreach</h4>
            </div>
          </div>
          <div className='col-md-6 col-lg-4 col-xl-2'>
            <div className='imp-link_blk'>
            <LazyLoad><img src="https://webapi.entab.info/api/image/CCSDH/public/Images/nss.png" className='img-fluid' alt="Carmel Convent School, dharuhera" /></LazyLoad>
              <h4>Carmel NSS</h4>
            </div>
          </div>
          <div className='col-md-6 col-lg-4 col-xl-2'>
            <div className='imp-link_blk'>
            <LazyLoad><img src="https://webapi.entab.info/api/image/CCSDH/public/Images/nss.png" className='img-fluid' alt="Carmel Convent School, dharuhera" /></LazyLoad>
              <h4>Carmel BSG</h4>
            </div>
          </div>
          <div className='col-md-6 col-lg-4 col-xl-2'>
            <div className='imp-link_blk'>
            <LazyLoad><img src="https://webapi.entab.info/api/image/CCSDH/public/Images/idaan.png" className='img-fluid' alt="Carmel Convent School, dharuhera" /></LazyLoad>
              <h4>Carmel IDAAN</h4>
            </div>
                </div> */}
          <div className='col-md-6 col-lg-4 col-xl-2 mx-auto d-block'>
            <div className='imp-link_blk'>
            <LazyLoad><img src="https://webapi.entab.info/api/image/CCSDH/public/Images/youtube.png" className='img-fluid' alt="Carmel Convent School, dharuhera" /></LazyLoad>
              <h4>Carmel On Youtube</h4>
            </div>
          </div>
          {  /*  <div className='col-md-6 col-lg-4 col-xl-2'>
            <div className='imp-link_blk'>
            <LazyLoad><img src="https://webapi.entab.info/api/image/CCSDH/public/Images/ceo-club.png" className='img-fluid' alt="Carmel Convent School, dharuhera" /></LazyLoad>
              <h4>Carmel CEO CLUB</h4>
            </div>
              </div> */}
        </div>
      </div>
    </div>
 
      <div className="event">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
            <div className='title'>
            <LazyLoad>   <p>Event section  <img src='https://webapi.entab.info/api/image/CCSDH/public/Images/calender.gif'  alt="Carmel Convent School, dharuhera" className='img-fluid' /></p></LazyLoad>
                <h2>Recent events</h2>
              </div>
              <p>Carmel is a vibrant and busy place, our news and events section keeps you up tp date with what’s going on. Share our events and joys - <span>we don’t want you to miss a thing!</span></p>
            </div>
            <div className="col-lg-12">
               <Events />  

            </div>
          </div>
        </div>
      </div>
       
      <div className="gallery">
        <div className="container">
          <div className="row">
            <div className='col-md-12'>
              <div className='title'>
              <LazyLoad> <p>Gallery section <img src='https://webapi.entab.info/api/image/CCSDH/public/Images/gallery.gif' alt="Carmel Convent School, dharuhera" className='img-fluid' /> </p></LazyLoad>
                <h2>Photo Gallery</h2>
              </div>
            </div>
            <div className="col-lg-12">
             <Gallery />  
              {/* <button className='button'><Link to="/gallery">View More</Link></button> */}
            </div>
          </div>
        </div>
      </div>
       <Footer />    
    </>

  )
}

export default Home

